import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

// COMPONENTS
import SignOutModal from "./SignOutModal";
// REDUX ACTIONS
import { login } from "../../redux/actions/auth";
// CSS STYLES
import styles from "../../styles/AuthenticationLogin/AuthNavbar.module.css"
// ICONS
import { TfiMenu } from 'react-icons/tfi';

const defaultImage = '/static/img/ImsLogos/IMS_Horizontal_Logo.png';

const AuthMobileMenu = ({
    // STATES
    openMenu,
    setOpenMenu,
    // FUNCTIONS
    handleNavbarButton,
    // REDUX ACTIONS
    login,
    // REDUX REDUCERS
    auth: { 
        isAuthenticated, 
        user 
    },
}) => {

    const handleClose = (e) => {

        if (!(e?.target?.className?.length > 0)) return
        if (e.target.className?.includes('authMobile_container_open')) {
            setOpenMenu(false);
        }
    };



    return (
        <div className={!openMenu? styles.authMobile_container_closed : styles.authMobile_container_open} onClick={(e)=>handleClose(e)}>
            
            <div onClick={()=> {setOpenMenu(!openMenu)}} className={styles.hamburger_container} style={openMenu? {display: 'none'} : {display: 'flex'}}>
                <TfiMenu size={30}/>
            </div>


            <div className={styles.menu} style={!openMenu ? {right: '-240px', top: '0',opacity:1}:{right: '0',top: '0px', opacity:1}}>

                <p 
                    className={styles.authNavbar_single_link}
                    onClick={() => {handleNavbarButton('Admin')}}
                >
                    Admin
                </p>
                <p 
                    className={styles.authNavbar_single_link}
                    onClick={() => {handleNavbarButton('Account')}}
                >
                    Account
                </p>
                <p 
                    className={styles.authNavbar_single_link}
                    onClick={() => {handleNavbarButton('SignOut')}}
                >
                    Sign Out
                </p>

            </div>

        </div>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {
    login
})(AuthMobileMenu);
